import {
  ApprovalsResponse,
  DownloadFile,
  DownloadLink,
  DownloadTask,
  RightCreditsResponse,
  RightResponse,
  SongApiService,
  SongLink,
  ApiError,
  DownloadLinkWithProgressBar,
} from 'src/app/song/types';
import { Inject, Injectable } from '@angular/core';
import { interval, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../../../src/app/shared/services/api.service';
import { songSearch } from '../../../../../src/app/mocks/song-search.mock';
import { SearchRecordings } from '../../../../../src/app/recordings/state/recording.model';
import { IUser } from 'src/app/user/user.model';

@Injectable({
  providedIn: 'root',
})
export class PitchSongsApiService implements SongApiService {
  secondPlay$: Subject<number | string> = new Subject<number | string>();
  pitchHash: string;

  constructor(@Inject('ApiService') private api: ApiService, private http: HttpClient) {}

  getTrackLink(id: number, download = false): Observable<SongLink> {
    const params = {
      download: download ? 'true' : 'false',
    };
    return this.api.get(`pitch/${this.pitchHash}/recordings/${id}/link`, { params }).pipe(
      catchError(error => {
        return of({
          content: null,
          error,
        });
      })
    );
  }

  createDownloadLink(id?: number, downloadAll: boolean = false): Observable<DownloadTask | ApiError> {
    const params = {
      recordingId: id,
      downloadAll,
    };
    return this.api.post<DownloadTask>(`pitch/${this.pitchHash}/download_links`, { ...params }, {}).pipe(
      catchError(error => {
        return of({
          content: null,
          error,
        });
      })
    );
  }

  getDownloadLink(linkId: number): Observable<DownloadLink> {
    return this.api.get<DownloadLink>(`pitch/${this.pitchHash}/download_links/${linkId}`, {});
  }

  getDownloadLinkAndProgress(taskId: number): Observable<DownloadLinkWithProgressBar> {
    return this.api.get<DownloadLinkWithProgressBar>(`pitch/${this.pitchHash}/recordings/downloads/progress/${taskId}`);
  }

  setPitchID(pitchHash): void {
    this.pitchHash = pitchHash;
  }

  getWaveform() {
    return [];
  }

  requestSong() {
    return of({});
  }

  download(id?: number, downloadAll?: boolean): Observable<DownloadFile> {
    return this.createDownloadLink(id, downloadAll).pipe(
      switchMap((createLinkResponse: DownloadTask) => {
        return createLinkResponse.success
          ? of(createLinkResponse.id)
          : throwError(new Error('Can\'t generate download song request'));
      }),
      switchMap((createLinkId: number) => {
        return interval(3000).pipe(
          switchMap(() => this.getDownloadLinkAndProgress(createLinkId)),
          map((downloadLinkResponse: DownloadLink) => {
            if (['failed', 'expired'].indexOf(downloadLinkResponse.status) !== -1) {
              throw new Error(`Download link is ${downloadLinkResponse.status}`);
            }

            return downloadLinkResponse;
          }),
          filter((downloadLinkResponse: DownloadLinkWithProgressBar) => downloadLinkResponse.status === 'created'),
          take(1)
        );
      }),
      switchMap((downloadLinkResponse: DownloadLinkWithProgressBar) => {
        return downloadLinkResponse.link
          ? this.http
              .get(downloadLinkResponse.link, {
                responseType: 'blob',
              })
              .pipe(
                map((response: Blob) => ({
                  source: response,
                  link: downloadLinkResponse.link,
                }))
              )
          : throwError(new Error('Can\'t download song'));
      }),
      take(1)
    );
  }

  getRights(): Observable<RightResponse> {
    return throwError(() => new Error('something wrong!'));
  }
  getRightsCredits(): Observable<RightCreditsResponse> {
    return throwError(() => new Error('something wrong!'));
  }
  getApprovals(): Observable<Array<ApprovalsResponse>> {
    return throwError(() => new Error('something wrong!'));
  }
  requestUserInfo(): Observable<IUser> {
    return this.api.get<IUser>('users/current_user_info', {});
  }

  updateUserAlbumArtFlag(flag: boolean): Observable<any> {
    return this.api.put('songs/search/settings', {
      showAlbumsArt: flag,
    });
  }

  getVersions(): Observable<SearchRecordings> {
    return of(songSearch);
  }
}
